import React, { FC, useEffect } from 'react';
import { Header } from '@airtel-web/legos';
import { ANALYTICS_CONSTANTS } from '../../../../common/constants/AnalyticsConstants';
import { isUserLoggedIn } from '../../../../utils/utils';

const HeaderSection: FC = () => {
   const data = {
      journey: ANALYTICS_CONSTANTS.webHomepage,
      eventCategory: ANALYTICS_CONSTANTS.webHomepage,
      prop0: ANALYTICS_CONSTANTS.homepage,
   };

   useEffect(()=>{
      sessionStorage?.setItem('showCB', 'true');
   },[])

   const handleNavClick = ({id}: {id: string}) => {
      if (id === 'help-and-support-chat') {
         sessionStorage?.setItem('chatAnalyticsSrc', 'helpAndSupportLogin');
      }else if (id === 'profile-menu-login'){
         sessionStorage?.setItem('chatAnalyticsSrc', 'homepageLogin');
      }else if (id === 'profile-menu-manage-services'){
         sessionStorage?.setItem('chatAnalyticsSrc', 'homepageManageServices');
      }
   }

   return (
      <Header
         className="header-section"
         isUserLoggedIn={isUserLoggedIn()}
         trackingData={data}
         appName="homepage"
         showHelpAndSupport
         onNavClickHandler={handleNavClick}
      />
   );
};

export default HeaderSection;